<template>
  <div class="coach-select-box">
    <div v-for="(list, index) in coachSelectVOForm" :key="index" class="flex" style="margin-bottom: 10px;">
      <el-select
        v-model="coachSelectVOForm[index].level"
        placeholder="请选择教练级别"
        style="margin-right: 20px"
        @change="handleCoachSelectChange(index)"
      >
        <el-option
          v-for="item in coachLevels"
          :key="item.id"
          :label="item.level"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-if="coachSelectVOForm[index].level"
        v-model="coachSelectVOForm[index].id"
        placeholder="请选择教练名称"
        @change="coachSelectChange"
      >
        <el-option
          v-for="it in coachSelectVO[coachSelectVOForm[index].level]"
          :key="it.id"
          :label="it.firstName + it.lastName"
          :value="it.id"
        />
      </el-select>
      <div
        v-if="index !== 0 && coachSelectVOForm[index].level"
        class="form-icon"
        @click="handleRemoveCoach(index)"
      >
        <el-icon class="el-icon-close" />
      </div>
    </div>
    <div class="form-add">
      <el-button icon="el-icon-plus" @click="handleAddCoach">添加课程教练</el-button>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      list: [
        { id: 1, level: "Master", firstName: "张", lastName: "伟丽" },
        { id: 2, level: "Team", firstName: "何", lastName: "伟丽" },
        { id: 3, level: "Member", firstName: "王", lastName: "伟丽" },
        { id: 4, level: "Master", firstName: "赵", lastName: "伟丽" },
        { id: 5, level: "Team", firstName: "钱", lastName: "伟丽" },
        { id: 6, level: "Member", firstName: "李", lastName: "伟丽" },
        { id: 7, level: "Master", firstName: "周", lastName: "伟丽" },
        { id: 8, level: "Member", firstName: "冯", lastName: "伟丽" },
        { id: 9, level: "Master", firstName: "龚", lastName: "伟丽" },
        { id: 10, level: "Team", firstName: "王", lastName: "大大" },
        { id: 11, level: "Master", firstName: "孙", lastName: "伟丽" },
        { id: 15, level: "Master", firstName: "测", lastName: "试" },
        { id: 17, level: "Master", firstName: "测", lastName: "试" },
        { id: 18, level: "Master", firstName: "测", lastName: "试" },
        { id: 21, level: "Member", firstName: "张", lastName: "三" },
        { id: 22, level: "Team", firstName: "张", lastName: "三" },
        { id: 23, level: "Member", firstName: "张", lastName: "三" },
        { id: 24, level: "Member", firstName: "张", lastName: "三" },
        { id: 25, level: "Member", firstName: "张", lastName: "三" },
        { id: 26, level: "Master", firstName: "唐", lastName: "Master" },
        { id: 27, level: "Member", firstName: "唐", lastName: "Member" },
        { id: 28, level: "Team", firstName: "唐", lastName: "Team" },
      ],
      coachSelectVOForm: [],
      coachSelectVOList: [],
    };
  },
  computed: {
    coachLevels() {
      return this.$store.state.activity.coachLevels || [];
    },
    coachSelectVO() {
      return this.$store.state.activity.coachSelectVO.reduce((pre, current) => {
      // return this.list.reduce((pre, current) => {
        if (!pre[current.level]) {
          pre[current.level] = [];
        }
        pre[current.level].push(current);
        return pre;
      }, {});
    },
    coachSelectList() {
      return this.$store.state.activity.coachSelectVO.reduce((pre, current) => {
      // return this.list.reduce((pre, current) => {
        if (pre.findIndex(item => item.level === current.level) === -1) {
          pre.push(current);
        }
        return pre;
      }, []);
    },
    ids() {
      return this.coachSelectVOForm.map(item => item.id);
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val.length) {
          this.coachSelectVOForm = [].concat(val);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleRemoveCoach(index) {
      this.coachSelectVOForm.splice(index, 1);
      // this.coachSelectVOForm.splice(
      //   this.coachSelectVOForm.findIndex(index =>{
      //       item.time === time
      //   } ),
      //   1
      // )
      this.$emit('change', this.coachSelectVOForm);
      this.$parent.$emit("el.form.change");
    },
    handleAddCoach() {
      this.coachSelectVOForm.push({
        id: "",
        level: "",
        firstName: "",
        lastName: "",
        time: Date.parse(new Date()),
      });
      this.$emit('change', this.coachSelectVOForm);
    },
    coachSelectChange() {
      this.$emit('change', this.coachSelectVOForm);
    },
    handleCoachSelectChange(index) {
      this.coachSelectVOForm.forEach((item, i) => {
        if (i === index) {
          item.id = '';
        }
      });
      this.$emit('change', this.coachSelectVOForm);
    },
  },
};
</script>

<style></style>
